import { memo } from 'react';

import { ViewTypeName } from '@air/api/types';

import { type DefaultBoardlessConfigViewsParams } from '~/constants/configViews';
import { useBoardlessConfigViewObserver } from '~/hooks/useBoardlessConfigView/useBoardlessConfigViewObserver';
import { useGetPrivateConfigViewOptions } from '~/swr-hooks/gallery/viewFields/useGetPrivateConfigViewsOptions';

type BoardlessConfigViewObserverProps = {
  pageId: string;
  defaultSort?: DefaultBoardlessConfigViewsParams['defaultSort'];
};

export const BoardlessConfigViewObserver = memo(({ pageId, defaultSort }: BoardlessConfigViewObserverProps) => {
  const { data: galleryConfigOptions } = useGetPrivateConfigViewOptions({ viewType: ViewTypeName.gallery });
  const { data: tableConfigOptions } = useGetPrivateConfigViewOptions({ viewType: ViewTypeName.table });

  useBoardlessConfigViewObserver({
    defaultSort,
    galleryConfigOptionsData: galleryConfigOptions?.data,
    pageId,
    tableConfigOptionsData: tableConfigOptions?.data,
  });

  return null;
});

BoardlessConfigViewObserver.displayName = 'BoardlessConfigViewObserver';
